import * as React from 'react'

import { assertString, assertNumber, assertTrue } from '../../utils/assert';
import { FormGroup } from "./FormGroup";

export interface FormItemProps
{
    title?: string;
}

export class FormItemVertical extends React.Component<FormItemProps, any>
{
    render()
    {
        const { children, title } = this.props;
        
        if(title) {
            assertString(title);
        }
        
        return (
            <FormGroup>
                <label className="control-label text-right">{title}</label>
                <div>
                    {children}
                </div>
            </FormGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Forms/FormItemVertical.tsx